module.exports = __webpack_public_path__ + "img/mr05ln.e2d18ba6.png";